import AsyncSelect from "react-select/async";
import { BsCaretDownFill } from "react-icons/bs";
import { Wrapper } from "../../layout";
// import InputValidationWarning from "../InputValidationWarning";
import AmerLabel from "../AmerLabel";

export default function ControlledAsyncSelectInput({
  label,
  placeholder,
  loadOptions,
  selectedData,
  handleSelect,
  isLoading = false,
  warning,
  invalid,
  onInputChange,
  id,
  required,
  bold,
}) {
  return (
    <Wrapper>
      <AmerLabel value={label}  bold={bold} required={required}/>
      <AsyncSelect
          value={selectedData}
          className={"autocomplete-input"}
          onChange={handleSelect}
          cacheOptions
          loadOptions={loadOptions}
          isLoading={isLoading}
          isClearable={true}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          placeholder={placeholder}
          onInputChange={onInputChange}
          components={{
            DropdownIndicator: (event) => {
                if (!event.hasValue && !event.isFocused) {
                  return (
                    <BsCaretDownFill
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        pointerEvents: "none",
                        fill: "#606061",
                        transform: "translateY(-50%)",
                      }}
                    />
                  );
                }
                return null;
            },              
            IndicatorSeparator: () => null,
          }}
          styles={{
            control: baseStyles => ({
                ...baseStyles,
                minHeight: 58,
                fontSize: "15px",
                textAlign: "left",
                color: "#00000039",
                border: "solid 4px #00000039",
                minWidth:200
            }),
            menu: provided => ({ ...provided, zIndex: 10, textAlign: "left" })
        }}
        />
      {/* <InputValidationWarning warning={warning} /> */}
    </Wrapper>
  );
}